export default "<h3>Connector Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"